import styled from 'styled-components';

import { color, breakpoint } from '@ovpn/ui/tokens';

const FixedFooter = styled.div`
    position: fixed;
    bottom: 24px;
    z-index: 2;

    justify-content: flex-start;
    width: 100%;
    margin-bottom: -24px;
    margin-left: -32px;
    padding: 24px 32px;

    background: rgba(255, 255, 255, 0.85);
    border-top: 1px solid ${color.neutral.bgHover};
    backdrop-filter: blur(2px);

    @media (max-width: ${breakpoint.md}px) {
        margin-left: -24px;
        padding: 24px;
    }

    @media (max-width: ${breakpoint.sm}px) {
        margin-left: -16px;
        padding: 24px 16px;
    }
`;

export default FixedFooter;
